export const ENVs = {
  StaticBucketUrl: (): string => {
    const env = (window as { frontendENV?: { STATIC_BUCKET?: string } }).frontendENV;
    return env?.STATIC_BUCKET ?? '';
  },
};
